import Vue from 'vue';
import VueRouter from 'vue-router';
import Login from '../pages/Login.vue';
import Dashboard from '../pages/Dashboard.vue';
import History from '../pages/History.vue';
import InvoiceHistory from '../pages/InvoiceHistroy.vue';
import ProcessedByUser from '../pages/ProcessedByUser.vue';
import Settings from '../pages/Settings.vue';
import GeneralSettings from '../pages/GeneralSettings.vue';
import Partners from '../pages/Partners.vue';
import DocumentIssuers from '../pages/DocumentIssuers.vue';
import PartnerIbans from '../pages/Ibans.vue';
import EmailMapping from '../pages/EmailMapping.vue';
import Currencies from '../pages/Currencies.vue';
import Splitting from '../pages/Splitting.vue';
import store from '../vuex/store';
import PaymentType from '@/pages/PaymentType.vue';
import Countries from '@/pages/Countries.vue';
import ExternalApproval from '@/pages/ExternalApproval.vue';

Vue.use(VueRouter);

const router = new VueRouter({
  hashbang: false,
  mode: 'history',
  routes: [
    {
      path: '/dashboard',
      name: 'dashboard',
      component: Dashboard,
      meta: { requiresAuth: true },
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: { requiresAuth: false },
    },
    {
      path: '/external-approval',
      name: 'ExternalApproval',
      component: ExternalApproval,
      meta: { requiresAuth: false },
    },
    {
      path: '/splitting',
      name: 'splitting',
      component: Splitting,
      meta: { requiresAuth: true },
    },
    {
      path: '/history',
      name: 'history',
      component: History,
      meta: { requiresAuth: true },
      children: [
        {
          name: 'default-history',
          path: '',
          component: InvoiceHistory,
        },
        {
          name: 'processed-by-user',
          path: 'processed-by-user',
          component: ProcessedByUser,
        },
        {
          name: 'invoice-list',
          path: 'invoice-list',
          component: InvoiceHistory,
        },
      ],
    },
    {
      path: '/settings',
      name: 'settings',
      component: Settings,
      meta: { requiresAuth: true },
      children: [
        {
          name: 'default-settings',
          path: '',
          component: GeneralSettings,
        },
        {
          name: 'general',
          path: 'general',
          component: GeneralSettings,
        },
        {
          name: 'partners',
          path: 'partners',
          component: Partners,
        },
        {
          name: 'document-issuers',
          path: 'document-issuers',
          component: DocumentIssuers,
        },
        {
          name: 'partner-iban',
          path: 'partner-iban',
          component: PartnerIbans,
        },
        {
          name: 'email-mapping',
          path: 'email-mapping',
          component: EmailMapping,
        },
        {
          name: 'currencies',
          path: 'currencies',
          component: Currencies,
        },
        {
          name: 'payment-type',
          path: 'payment-type',
          component: PaymentType,
        },
        {
          name: 'countries',
          path: 'countries',
          component: Countries,
        },
      ],
    },
  ],
});

router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth) {
    if (!store.getters.isLoggedIn) {
      next('/login');
    } else {
      next();
    }
  } else if (!to.name) {
    if (store.getters.isLoggedIn) {
      next('/dashboard');
    } else {
      next('/login');
    }
  } else {
    next();
  }
});

export default router;
